import axios from 'axios'
import { getRequestConfig } from 'client/api/index'
import { CustomSettingsInterface } from 'client/Interfaces/CustomSettingsInterface'

export async function getCustomSettings(): Promise<CustomSettingsInterface> {
  const response = await axios.get('/templates/document/custom', getRequestConfig())
  return response.data
}

export async function saveCustomSettings(data): Promise<CustomSettingsInterface> {
  const response = await axios.put('/templates/document/custom', data, getRequestConfig())
  return response.status === 200 ? data : {}
}
